module.exports = __webpack_public_path__ + "b8c9a7606adb83a4c4b1e3162fae8455.pdf";